import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        checkoutMainGaps: {
            gap: {base: 'small.base', sm: 0, md: 0, lg: 'small.lg', xl: remCalc(142)},
        },
        toggleCardBox: {
            //py: {base: 0, lg: remCalc(24)},
            textStyle: 'body-medium',
            flexDirection: 'column',
            bg: 'background.base.default',
        },
        toggleIconBox: {
            w: remCalc(24),
            backgroundColor: 'text.success',
            borderRadius: '50%',
            mr: remCalc(8),
        },
        ToggleCardStack: {
            gap: {base: 0},
        },
        toggleCheckIcon: {
            w: remCalc(24),
            h: remCalc(24),
            padding: remCalc(2.5),
        },
        billingACBox: {
            border: 'small',
            borderStyle: 'solid',
            borderColor: '#DEDCDA',
            borderRadius: 'large',
            bg: 'background.light-dark',
            padding: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
            w: '100%',
            _focus: {
                outline: 'none !important',
                boxShadow: 'none !important',
            },
            _focusVisible: {
                outline: '2px solid !important',
                outlineColor: 'blue.500 !important',
                outlineOffset: '2px !important',
                boxShadow: 'none !important',
            },
        },
        insideflex: {
            height: 'stretch',
            alignItems: 'flex-start',
            marginTop: remCalc(6),
        },
        radioAndAddress: {
            gap: remCalc(8),
        },
        billingACFlex: {
            mb: remCalc(8),
            gap: remCalc(16),
            alignItems: 'center',
            justifyContent: 'space-between',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        useLabel: {
            textStyle: 'body-small',
            fontWeight: 'bold',
        },
        billingRadioGap: {ml: remCalc(24)},
        billingAddressTypeGap: {marginBottom: remCalc(40)},
        shippingLoadingContainer: {
            flexDirection: 'column',
            gap: remCalc(24),
        },
        shippingLoading: {
            w: '100%',
            paddingTop: remCalc(54),
            position: 'relative',
        },
        giftMessageFlex: {
            flexDirection: 'column',
            gap: remCalc(8),
        },
        giftContainer: {
            mb: remCalc(24),
        },
        giftMainFlex: {
            gap: remCalc(24),
            flexDirection: 'column',
        },
        giftCheckboxFlex: {
            gap: remCalc(16),
            flexDirection: 'column',
        },
        giftDescription: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
        },
        shippingLabel: {
            textStyle: 'body-small',
            color: 'text.default',
            pb: remCalc(24),
            pt: remCalc(12),
        },
        giftTextContainer: {
            paddingY: remCalc(8),
        },
        checkboxText: {
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        giftCheckboxText: {
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        optionsApplicableShippings: {
            flexDirection: 'column',
            gap: remCalc(4),
        },
        optionsApplicableShippingsText: {
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        optionsApplicableShippingsDesc: {
            textStyle: 'body-small',
            color: 'text.secondary',
            fontWeight: 'medium',
        },
        optionsApplicableShippingsPrice: {
            textStyle: 'body-small',
            color: 'text.success',
            textTransform: 'uppercase',
            fontWeight: 'medium',
        },
        optionsShippingRegister: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
            mt: remCalc(8),
        },
        optionsShippingSummary: {
            borderRadius: 'large',
            bg: 'background.light-dark',
            border: 'small',
            borderStyle: 'solid',
            borderColor: '#DEDCDA',
            padding: remCalc(20),
            maxWidth: {base: '100%', md: '100%', lg: remCalc(450)},
            marginBottom: remCalc(24),
        },
        optionsShippingColumn: {
            flexDirection: 'column',
            gap: remCalc(8),
            textStyle: 'body-medium',
        },
        optionsStrong: {
            fontWeight: 'bold',
        },
        optionsSuccess: {
            textStyle: 'body-small',
            color: 'text.success',
            textTransform: 'uppercase',
            display: 'inline',
        },
        hideAdditionalInfoCardOnMobile: {
            flexDirection: 'column',
            gap: remCalc(8),
            display: {base: 'none', lg: 'flex'},
        },
        hideAdditionalInfoCardOnDesktop: {
            flexDirection: 'column',
            gap: remCalc(8),
            display: {base: 'flex', lg: 'none'},
            order: {base: 1, lg: 0},
        },
        'is-editing': {
            border: 'none',
            padding: 0,
        },
        gapCard: {
            gap: remCalc(16),
            alignItems: 'flex-start',
        },
        summaryShipping: {
            paddingBottom: remCalc(24),
        },
        subscriptionsCheckoutContainer: {
            height: 'auto',
            display: 'grid',
            gridTemplateColumns: {base: '1fr', lg: '1fr 1fr'},
        },
        registerAccountTitle: {
            textStyle: 'head-medium',
            fontWeight: 'medium',
            color: 'text.default',
            marginBottom: {base: remCalc(16), md: remCalc(24)},
            width: '100%',
        },
        termsAndConditionsContainer: {
            mt: remCalc(24),
            textStyle: 'body-small',
        },
        termsAndConditionsLink: {
            textDecoration: 'underline',
            fontWeight: 'bold',
        },
    },
    variants: {
        checkout: {
            toggleCardBox: {
                paddingTop: remCalc(24),
            },
        },
        options: {
            toggleCardBox: {
                py: 0,
            },
        },
        'profile-card': {
            toggleCardBox: {
                border: 'small',
                borderStyle: 'solid',
                borderRadius: 'large.base',
                borderColor: 'border.light',
                padding: remCalc(24),
                maxWidth: '100%',
            },
            ToggleCardStack: {
                position: 'relative',
                gap: {base: remCalc(40), lg: 0},
                flexDirection: {base: 'column-reverse', lg: 'row'},
                justifyContent: 'space-between',
            },
            gapCard: {
                padding: 0,
            },
            boxContent: {
                display: 'flex',
                gap: {base: 0, lg: remCalc(24)},
                w: '100%',
            },
            editButton: {
                textStyle: 'body-small',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                fontWeight: 'normal',
                position: 'absolute',
                right: {lg: 0}, // remCalc(24)
                top: {lg: 0}, // remCalc(24)
                bottom: {sm: 0, lg: 'unset'},
                // left: {sm: remCalc(24), lg: 'unset'},
                marginBottom: {sm: 0},
            },
            toggleCardEditModal: {
                content: {
                    margin: {base: remCalc(16), md: 'auto'},
                },
                header: {},
                body: {
                    padding: {base: remCalc(16), md: remCalc(24)},
                },
            },
        },
        'edit-card': {
            border: 'none',
            padding: 0,

            boxContent: {
                display: 'flex',
                flexDirection: 'column',
                gap: {base: 0, lg: remCalc(24)},
                w: '100%',
            },
        },
    },
}
